import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withIcon } from '../Icon';
export var SpeakerVolumeUpSVG = function SpeakerVolumeUpSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23.055 11.594C21.917 10.494 20.653 10 20 10a1 1 0 1 1 0-2c1.347 0 3.083.84 4.445 2.156C25.845 11.51 27 13.506 27 16c0 2.645-1.142 4.65-2.568 5.981C23.044 23.276 21.312 24 20 24a1 1 0 1 1 0-2c.689 0 1.956-.443 3.068-1.481C24.142 19.516 25 18.02 25 16c0-1.84-.846-3.344-1.945-4.406z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.76 13.971h-.003a1 1 0 1 1 .485-1.941c.634.158 1.306.695 1.794 1.314C22.552 14 23 14.92 23 16s-.448 2-.964 2.656c-.488.62-1.16 1.156-1.794 1.314a1 1 0 1 1-.485-1.94l.002-.001c.016-.007.099-.041.235-.143.147-.11.314-.269.47-.467.317-.403.536-.9.536-1.419 0-.52-.219-1.016-.536-1.419a2.605 2.605 0 0 0-.47-.467 1.099 1.099 0 0 0-.235-.143zm-3.336-6.877A1 1 0 0 1 17 8v16a1 1 0 0 1-1.64.768L9.638 20H6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h3.638l5.722-4.768a1 1 0 0 1 1.064-.138z",
    clipRule: "evenodd"
  })));
};
SpeakerVolumeUpSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
SpeakerVolumeUpSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Speaker Volume Up")
};
export default withIcon(SpeakerVolumeUpSVG);